import { useQuery } from '@tanstack/react-query';
import { querySites } from './endpoints';
import { sitePreviewKeys } from './keys';
import type { Site } from '@wix/ambassador-site-list-v2-site/types';
import { useMsId } from '../../../store/appStore';

export function useQuerySites() {
  const metaSiteId = useMsId();

  return useQuery<Site | null>({
    queryKey: sitePreviewKeys.querySites(metaSiteId || ''),
    queryFn: () => querySites(metaSiteId || ''),
    enabled: !!metaSiteId,
    staleTime: 30000, // 30 seconds
  });
}
